/**
 * confirm() — sostituisce window.confirm con modal professionale
 * Uso: const ok = await confirm("Eliminare questo elemento?")
 * Usa eventi per comunicare con ConfirmProvider nel App root
 */

let resolveRef = null;

export function confirm(message, options = {}) {
  return new Promise((resolve) => {
    resolveRef = resolve;
    window.dispatchEvent(new CustomEvent("nexiora:confirm", {
      detail: {
        message,
        title: options.title || "Conferma",
        type: options.type || "danger",
        confirmLabel: options.confirmLabel || "Conferma",
        cancelLabel: options.cancelLabel || "Annulla",
      }
    }));
  });
}

export function resolveConfirm(result) {
  if (resolveRef) { resolveRef(result); resolveRef = null; }
}
